document.documentElement.classList.remove('no-js');

(() => {
  const toggle = document.querySelector('[data-mobile-toggle]');
  const nav = document.querySelector('[data-mobile-nav]');
  if (toggle && nav) {
    toggle.addEventListener('click', () => {
      const open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  const gate = document.querySelector('[data-age-gate]');
  if (gate && gate.dataset.enabled === 'true') {
    const key = 'vapora_age_verified';
    if (localStorage.getItem(key) !== 'true') gate.classList.add('is-active');
    const enter = gate.querySelector('[data-age-enter]');
    const exit = gate.querySelector('[data-age-exit]');
    if (enter) enter.addEventListener('click', () => {
      localStorage.setItem(key, 'true');
      gate.classList.remove('is-active');
    });
    if (exit) exit.addEventListener('click', () => {
      window.location.href = gate.dataset.exitUrl || 'https://www.google.com/';
    });
  }

  document.querySelectorAll('[data-quick-add-form]').forEach((form) => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const button = form.querySelector('button[type="submit"]');
      if (!button) return;
      const original = button.textContent;
      button.disabled = true;
      button.textContent = 'Adding…';
      try {
        const res = await fetch('/cart/add.js', { method:'POST', headers:{'Accept':'application/json'}, body:new FormData(form) });
        if (!res.ok) throw new Error('Unable to add item');
        const cart = await fetch('/cart.js').then(r => r.json());
        document.querySelectorAll('[data-cart-count]').forEach(el => el.textContent = cart.item_count);
        const toast = document.querySelector('[data-cart-toast]');
        if (toast) {
          toast.textContent = 'Added to cart';
          toast.classList.add('is-visible');
          setTimeout(() => toast.classList.remove('is-visible'), 1800);
        }
      } catch (err) {
        HTMLFormElement.prototype.submit.call(form);
      } finally {
        button.disabled = false;
        button.textContent = original;
      }
    });
  });
})();
